import pathOr from 'ramda/src/pathOr';

export const getLoyaltyProgram = pathOr({}, ['settings', 'loyalty']);
